<template lang="pug">
  dialogs(:show.sync="visible" :option="{ size: 'ml', headerClass: 'type-3' }" :title="this.$t('management_page.security_pledge_management')")
    .form
      b-row
        b-form-group(
          content-cols-sm
          :label="$t('management_page.version_settings')"
          label-for="id"
          label-cols-sm="4"
          label-align-sm="left"
        )
          b-form-input.w-50.d-inline-block(v-model="postForm.security_agreement_version" size="sm" :disabled="isEdit")
      b-row
        b-form-textarea(
          v-model="postForm.content"
          rows="10"
          max-rows="10"
          :disabled="isEdit"
        )

    .modal-footer
      template(v-if="!isEdit")
        b-btn.btn-secondary(size="sm" @click="visible = false" pill) this.$t('cancel')
        b-btn(size="sm" variant="primary" @click="submit" pill) this.$t('enrollment')
      template(v-else)
        b-btn.btn-secondary(size="sm" @click="visible = false" pill) this.$t('submit')
</template>

<script>
import { SecurityAgreementAPI } from "@/api"
import Dialogs from "@/components/mixins/dialog/index.vue"
import _ from "lodash"

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    // isAdd: {
    //   type: Boolean,
    //   default: false,
    // },
  },
  components: {
    Dialogs,
  },
  watch: {
    show(newVal) {
      this.visible = newVal
      if (newVal) {
        this.isEdit = false
        if (_.isEmpty(this.form)) {
          this.postForm = {
            security_agreement_version: "",
            content: "",
          }
        } else {
          this.isEdit = true
          this.postForm = _.cloneDeep(this.form)
        }
      }
    },
    visible(newVal) {
      this.$emit("update:show", newVal)
    },
  },
  data() {
    return {
      visible: false,
      isEdit: false,
      postForm: {
        security_agreement_version: "",
        content: "",
      },
    }
  },
  methods: {
    submit() {
      if (_.isEmpty(this.postForm.security_agreement_version)) {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: this.$t('management_page.enter_version') },
        })
        return
      }
      if (_.isEmpty(this.postForm.content)) {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: this.$t('enter_content') },
        })
        return
      }
      const params = _.cloneDeep(this.postForm)
      SecurityAgreementAPI.post("", params).then(res => {
        this.$emit("complete")
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.form {
  padding: 10px 30px;
}
</style>
